(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('WidgetPluviometrosCtrl', WidgetPluviometros);

  WidgetPluviometros.$inject = [
    '$scope',
    '$rootScope',
    '$http',
    'googleChartApiPromise',
    'Dashboard'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function WidgetPluviometros($scope, $rootScope, $http, googleChartApiPromise, Dashboard) {
    const vm = this;
    const MOMENT_FORMAT_TOOLTIP = 'DD/MM';

    //////////////////////////////////////////
    // Controller data
    vm.loading = false;
    vm.empty = false;
    vm.error = false;
    vm.chart = null;
    vm.chartStyle = {
      width: '100%',
      height: '300px'
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.validChart = ValidChart;

    //////////////////////////////////////////
    // Function declarations

    function ValidChart() {
      return $scope.widget.dataModelOptions.dataInicial &&
             $scope.widget.dataModelOptions.dataFinal;
    }

    function RenderChart() {
      vm.empty = false;
      vm.error = false;
      vm.chart = {
        type: 'ColumnChart'
      };
      vm.loading = true;
      const propriedade = $scope.widget.dataModelOptions.propriedade || $rootScope.currentPropriedade;

      const request = $http.get(`${SERVER}v1/dados_meteorologicos`, {
        params: {
          data_inicial: $scope.widget.dataModelOptions.dataInicial,
          data_final: $scope.widget.dataModelOptions.dataFinal,
          propriedade: propriedade.id
        }
      });

      request.then((response) => {
        PrepareChart(response.data);
      });

      return request;
    }

    function PrepareChart(result) {
      vm.loading = false;
      if (result.length) {
        result.sort((a, b) => moment(a.data, MOMENT_DATE_ENGLISH_FORMAT) - moment(b.data, MOMENT_DATE_ENGLISH_FORMAT));
        const array = [['Data']];
        array[0] = array[0].concat(_.uniqBy(result, 'cd_pluviometro').map((data) => data.descricao));

        for (const data of result) {
          ProcessData(array, data);
        }

        CreateChart(array);
      } else {
        vm.empty = true;
      }
    }

    function ProcessData(array, data) {
      const date = moment(data.data, MOMENT_DATE_ENGLISH_FORMAT).format(MOMENT_FORMAT_TOOLTIP);
      let found = true;
      let entry = _.find(array, { 0: date });
      if (!entry) {
        entry = new Array(array[0].length).fill(0);
        entry[0] = date;
        found = false;
      }

      const index = array[0].indexOf(data.descricao);
      entry[index] = data.chuva;

      if (!found) {
        array.push(entry);
      }
    }

    function CreateChart(array) {
      googleChartApiPromise.then(() => {
        const dataTable = google.visualization.arrayToDataTable(array);

        vm.chart = ChartOptions();
        vm.chart.data = dataTable;

        vm.loading = false;
      });
    }

    function ChartOptions() {
      return {
        type: 'ColumnChart',
        data: {
          cols: [],
          rows: []
        },
        options: {
          title: '',
          subtitle: '',
          legend: { position: 'right' },
          vAxis: {
            title: 'Milímetros'
          },
          chartArea: {
            width: '70%',
            height: '70%',
            left: 80
          }
        }
      };
    }

    function CalcChartWidth() {
      return Dashboard.calcChartWidth($scope.widget.size.width);
    }

    //////////////////////////////////////////
    // Controller logic

    // eslint-disable-next-line max-lines-per-function
    $rootScope.initialize.then(() => {
      $scope.widget.data = {
        propriedades: $rootScope.propriedades.map((propriedade) => ({
          id: propriedade.id,
          descricao: propriedade.descricao
        }))
      };

      if ($scope.widget.dataModelOptions.intervalShortcut) {
        const today = moment();
        $scope.widget.dataModelOptions.dataInicial = today
          .clone()
          .subtract($scope.widget.dataModelOptions.intervalShortcut, 'days')
          .toDate();
        $scope.widget.dataModelOptions.dataFinal = today.toDate();
      }

      if (typeof $scope.widget.dataModelOptions.dataInicial === 'string') {
        $scope.widget.dataModelOptions.dataInicial = moment($scope.widget.dataModelOptions.dataInicial).toDate();
      }
      if (typeof $scope.widget.dataModelOptions.dataFinal === 'string') {
        $scope.widget.dataModelOptions.dataFinal = moment($scope.widget.dataModelOptions.dataFinal).toDate();
      }

      $scope.$watch('widget.dataModelOptions', () => {
        if (vm.validChart()) {
          const render = RenderChart();
          render.catch((error) => {
            vm.error = true;
            console.error('Erro ao renderizar gráfico', error);
          });
        }
      }, true);
      $scope.$watch('widget.size.width', () => {
        if ((vm.chart || {}).options) {
          vm.chart.options.width = `${CalcChartWidth() }px`;
        }
      });
    });
  }
}());
